(() => {
  "use strict";
  document.addEventListener("DOMContentLoaded", function () {
    const t = document.querySelectorAll(".tooltip-icon"),
      e = document.querySelector(".description-container"),
      n = e.querySelector(".title"),
      a = e.querySelector(".description"),
      i = document.querySelector(".arrow-prev"),
      r = document.querySelector(".arrow-next");
    let o = 0;
    function s(i) {
      const r = t[i];
      if (r) {
        (n.textContent = r.getAttribute("data-title")),
          (a.textContent = r.getAttribute("data-description"));
        const t = r.querySelector("img.img-default").getAttribute("src");
        e.querySelector("#popup-image").setAttribute("src", t);
      }
    }
    t.forEach(function (t, n) {
      t.addEventListener("click", function () {
        (o = n), s(n), (e.style.display = "block");
      });
    }),
      e
        .querySelector(".close-description")
        .addEventListener("click", function () {
          e.style.display = "none";
        }),
      i.addEventListener("click", function () {
        o > 0 && (o--, s(o));
      }),
      r.addEventListener("click", function () {
        o < t.length - 1 && (o++, s(o));
      }),
      s(0);
  });
/*   class t {
    constructor(t, e, n, a, i, r, o, s) {
      (this.colorSwatcherData = t),
        (this.productImageElement = e),
        (this.linkElement = n),
        (this.titleLinkElement = a),
        (this.buttonLinkElement = i),
        (this.reviewLinkElement = r),
        (this.product = o),
        (this.variantMeta = s),
        this.setupColorSwatchEvents();
    }
    setupColorSwatchEvents() {
      (this.colorSwatcherData.parentNode.style.cursor = "pointer"),
        this.colorSwatcherData.parentNode.addEventListener("click", () => {
          this.selectColorSwatch(), this.removeSwatchEvents();
        });
    }
    selectColorSwatch() {
      const t = this.colorSwatcherData.value,
        e = this.product.variants.filter((e) => e.title.includes(t));
      let a = e.find((t) => t.available);
      if ((!a && e.length > 0 && (a = e[0]), !a)) return;
      const i = a.id,
        r = [
          this.linkElement,
          this.titleLinkElement,
          this.buttonLinkElement,
          this.reviewLinkElement,
        ];
      for (const t of r) {
        const e = t.getAttribute("href");
        let n;
        if (t === this.reviewLinkElement)
          if (e.includes("variant=") && e.includes("&#reviews"))
            n = e.replace(/variant=\d+/, `variant=${i}`);
          else if (e.includes("variant="))
            n = e.replace(/variant=\d+/, "").replace("&#reviews", "");
          else {
            const t = e.includes("?") ? "&" : "?";
            n = `${e}${t}variant=${i}&#reviews`;
          }
        else if (!0 === a.available)
          if (e.includes("variant="))
            n = e.replace(/variant=\d+/, `variant=${i}`);
          else {
            const t = e.includes("?") ? "&" : "?";
            n = `${e}${t}variant=${i}`;
          }
        else n = e.replace(/(\?|&)variant=\d+/g, "");
        t.setAttribute("href", n);
      }
      if (
        (this.colorSwatcherData.parentNode.parentNode
          .querySelectorAll('input[type="radio"][name="color"]')
          .forEach((t) => {
            t.parentNode.style.border = "1px solid transparent";
          }),
        (this.colorSwatcherData.parentNode.style.border = "1px solid #005d6e"),
        this.variantMeta && this.variantMeta[i])
      ) {
        const t = this.variantMeta[i],
          e = t.image_url_mobile || t.image_url,
          r = t.image_url || a.featured_image.src;
        (this.productImageElement.src = n() ? e : r),
          (this.productImageElement.alt = a.name);
      }
    }
    setupSwatchMouseEvents() {
      this.colorSwatcherData.parentNode.addEventListener("mouseenter", () =>
        this.swatchMouseEnter()
      ),
        this.colorSwatcherData.parentNode.addEventListener("mouseleave", () =>
          this.swatchMouseLeave()
        );
    }
    swatchMouseEnter() {
      this.parentNode.classList.contains("selected") ||
        (this.parentNode.style.border = "1px solid #005d6e");
    }
    swatchMouseLeave() {
      this.parentNode.classList.contains("selected") ||
        (this.parentNode.style.border = "1px solid transparent");
    }
    removeSwatchEvents() {
      this.colorSwatcherData.parentNode.removeEventListener("mouseenter", () =>
        this.swatchMouseEnter()
      ),
        this.colorSwatcherData.parentNode.removeEventListener(
          "mouseleave",
          () => this.swatchMouseLeave()
        );
    }
  } */
  class e { 
    constructor(e, a, i) {
      (this.product = e),
        (this.variantMeta = i),
        (this.colorSwatcherContainerData = a),
        (this.reviewLinkElement = n()
          ? document.getElementById(
              `review-link-mobile-${this.colorSwatcherContainerData.dataset.productIndex}`
            )
          : document.getElementById(
              `review-link-${this.colorSwatcherContainerData.dataset.productIndex}`
            ));
      const r = e.variants.find((t) => t.available);
      if (r) {
        const t = r.id,
          e = this.reviewLinkElement.getAttribute("href"),
          n = e.includes("?") ? "&" : "?",
          a = `${e}${n}variant=${t}&#reviews`;
        this.reviewLinkElement.setAttribute("href", a);
      }
      (this.selectedVariant =
        e.variants[this.colorSwatcherContainerData.dataset.productIndex - 1]),
        (this.productImageElement = n()
          ? document.getElementById(
              `product-image-mobile-${this.colorSwatcherContainerData.dataset.productIndex}`
            )
          : document.getElementById(
              `product-image-${this.colorSwatcherContainerData.dataset.productIndex}`
            )),
        (this.linkElement = n()
          ? document.getElementById(
              `product-link-mobile-${this.colorSwatcherContainerData.dataset.productIndex}`
            )
          : document.getElementById(
              `product-link-${this.colorSwatcherContainerData.dataset.productIndex}`
            )),
        (this.titleLinkElement = n()
          ? document.getElementById(
              `title-link-mobile-${this.colorSwatcherContainerData.dataset.productIndex}`
            )
          : document.getElementById(
              `title-link-${this.colorSwatcherContainerData.dataset.productIndex}`
            )),
        (this.buttonLinkElement = n()
          ? document.getElementById(
              `button-link-mobile-${this.colorSwatcherContainerData.dataset.productIndex}`
            )
          : document.getElementById(
              `button-link-${this.colorSwatcherContainerData.dataset.productIndex}`
            ));
      let o = this.colorSwatcherContainerData.querySelectorAll(
        'input[type="radio"][name="color"]'
      );
      (o[0].parentNode.style.border = "1px solid #005d6e"),
        o.forEach((e) => {
          new t(
            e,
            this.productImageElement,
            this.linkElement,
            this.titleLinkElement,
            this.buttonLinkElement,
            this.reviewLinkElement,
            this.product,
            this.variantMeta
          );
        });
    }
  }
  function n() {
    return window.matchMedia("(max-width: 991px)").matches;
  }
  window.addEventListener("DOMContentLoaded", () => {
    !(function () {
      let t = productsGlobal,
        a = variantsMetafieldDictionary,
        i = n()
          ? document.querySelectorAll(".mobile-color-swatcher-container")
          : document.querySelectorAll(".color-swatcher-container"),
        r = [];
      i.forEach((n) => {
        r.push(new e(t[n.dataset.productIndex - 1], n, a));
      });
    })();
  });
})();
